import React, { useEffect, useState } from "react";
import { Box, ChakraProvider, ColorModeScript, Spinner } from "@chakra-ui/react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import { initializeTheme } from "./redux/Theme";
import theme from "./theme/theme";
import { ThemeProvider } from "./context/ThemeContext";
import "./interceptors/axios";
import API from "./context/API";
import axios from "axios";
import AppRoutes from "./routes";
import Layout from "./theme/Layout/Layout";
import { ApiProvider } from "./context/ApiContext";
import LoginPage from "./components/LoginPage";
import { Logout } from "./components/logout";
import { LoadingProvider } from "./context/LoadingContext";
import OtpPhoneInput from "./components/OTPInput";
import ForgotPasswordPage from "./components/ForgotPasswordPage";
import ResetPasswordPage from "./components/ResetPasswordPage";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginData, setLoginData] = useState(null);
  const [role, setRole] = useState("");
  const [dynamicRoutes, setDynamicRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initializeTheme());
  }, [dispatch]);

  useEffect(() => {
    const hostname = window.location.hostname;
    if (window.location.protocol === "https:" && hostname === "kiwikrave.com") {
      window.location.href = "https://merchant.kiwikrave.com";
    }

    const validateAccessToken = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("access_token");
      const role1 = urlParams.get("role");

      if (token) {
        localStorage.setItem("access_token", token);

        try {
          let data = null;
          if (role1 === "merchant") {
            const res = await API.get("merchant/profile", {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            data = res.data.data;
          }

          if (role1 === "admin") {
            const res = await API.get("admin/profile", {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            data = res.data.data;
          }

          localStorage.setItem("user", JSON.stringify(data));
          localStorage.setItem("role", data.role);
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          
          window.location.href = "/dashboard";
          setIsLoggedIn(true);
          setRole(data.role);
        } catch (error) {
          console.error("Token validation failed:", error);
          localStorage.removeItem("access_token");
          localStorage.removeItem("user");
          localStorage.removeItem("role");
          setIsLoggedIn(false);
        }
      } else {
        const storedToken = localStorage.getItem("access_token");
        const storedRole = localStorage.getItem("role");

        if (storedToken && storedRole) {
          setIsLoggedIn(true);
          setRole(storedRole);
        } else {
          setIsLoggedIn(false);
        }
      }
      setLoading(false);
    };

    validateAccessToken();
  }, []);

  if (loading) {
    return (
      <Box textAlign="center" mt="4">
        <Spinner size="xl" />
      </Box>
    );
  }

  return (
    <ChakraProvider theme={theme}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <ThemeProvider>
        <ApiProvider>
          <LoadingProvider>
            <Router>
              <Routes>
                <Route
                  path="/otpverify"
                  element={
                    <OtpPhoneInput
                      setIsLoggedIn={setIsLoggedIn}
                      otp={loginData?.otp}
                      phone={loginData?.phone}
                      role={role}
                    />
                  }
                />
                <Route
                  path="/login"
                  element={
                    isLoggedIn ? (
                      <Navigate replace to="/login" />
                    ) : (
                      <LoginPage
                        isLoggedIn={isLoggedIn}
                        setIsLoggedIn={setIsLoggedIn}
                        setRole={setRole}
                        setLoginData={setLoginData}
                      />
                    )
                  }
                />
                <Route
                  path="/forgot-password"
                  element={
                    isLoggedIn ? (
                      <Navigate replace to="/dashboard" />
                    ) : (
                      <ForgotPasswordPage />
                    )
                  }
                />
                <Route
                  path="/reset-password"
                  element={
                    isLoggedIn ? (
                      <Navigate replace to="/dashboard" />
                    ) : (
                      <ResetPasswordPage />
                    )
                  }
                />
                <Route
                  path="/*"
                  element={
                    isLoggedIn ? (
                      <Layout role={role} setDynamicRoutes={setDynamicRoutes}>
                        <AppRoutes dynamicRoutes={dynamicRoutes} role={role} />
                      </Layout>
                    ) : (
                      <Navigate replace to="/login" />
                    )
                  }
                />
                <Route path="/logout" element={<Logout />} />
              </Routes>
            </Router>
          </LoadingProvider>
        </ApiProvider>
      </ThemeProvider>
    </ChakraProvider>
  );
}

export default App;
